import React, { ReactNode } from "react";

import Message from "./Message";
import classNames from "classnames";
import Tooltip from "../Tooltip";
import "./styles.scss";

interface FormFieldProps {
  id?: string;
  name: string;
  label?: string | JSX.Element;
  subLabel?: string;
  children: ReactNode;
  className?: string;
  errorMessage?: string;
  helperMessage?: string;
  tooltip?: string;
  validate?: boolean;
  validField?: boolean;
  disclaimerBeforeField?: string;
  disclaimerAfterField?: string;
  disclaimerAlert?: string;
  successNote?: string;
  dataQa?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  id,
  name,
  label,
  subLabel,
  children,
  className,
  errorMessage,
  helperMessage,
  tooltip,
  validate = true,
  validField = false,
  disclaimerBeforeField,
  disclaimerAfterField,
  disclaimerAlert,
  successNote,
  dataQa,
}) => {
  const fieldClassName = classNames(className, {
    "is-invalid": !validate,
    "is-valid": validField, // Prevent SSR/CSR mismatch
  });

  return (
    <div
      data-qa={dataQa}
      data-testid={validate ? name : "is-invalid"}
      className={fieldClassName}>
      {label && (
        <label
          htmlFor={!tooltip ? id : undefined}
          className={`input__label input__label-${name}`}>
          {label}
          {tooltip && (
            <Tooltip
              position="left"
              openOnClick={true}
              dataFor={`m-tooltip__${name}`}
              content={tooltip}
            />
          )}
        </label>
      )}

      {subLabel && <p className="form-subTitle small">{subLabel}</p>}

      <Message
        type="disclaimerBeforeField"
        content={disclaimerBeforeField}
      />
      {children}
      <Message
        type="error"
        content={errorMessage}
      />
      <Message
        type="helper"
        content={helperMessage}
      />
      <Message
        type="disclaimerAfterField"
        content={disclaimerAfterField}
      />
      <Message
        type="disclaimerAlert"
        content={disclaimerAlert}
        showIcon
      />
      <Message
        type="successNote"
        content={successNote}
        showIcon
      />
    </div>
  );
};

export default FormField;
